export const GET_OPERATION = 'getOperation'
export const GET_OPERATION_REPORT = 'getOperationReport'
